export const headerUserThumbnailSize = 40;

export const MAX_USERS_COUNT_TO_SHOW = 3;
